import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import { PushDeliveryGetRequest } from "@/api/analysis/push-delivery/request";
import { PushDeliveryGetResponse } from "@/api/analysis/push-delivery/response";
import * as AnalyticsPushDeliveryAPI from "@/api/analysis/push-delivery";
import { isSuccess } from "@/api/response";
import { AnalysisGraphData } from "@/api/analysis/common/response";

const MODULE_NAME = "analysis/push-delivery/get";

/**
 *  プッシュ配信数API（/analysis-push-delivery）のレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Get extends VuexModule {
  // state
  getRequest: PushDeliveryGetRequest = {} as PushDeliveryGetRequest;
  getResponse: PushDeliveryGetResponse = {} as PushDeliveryGetResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.getResponse);
  }

  get getMessage() {
    return this.getResponse.message;
  }

  get getData() {
    if (this.getResponse.results) {
      return this.getResponse.results.data;
    } else {
      return {} as AnalysisGraphData;
    }
  }

  get getTotalCount() {
    if (this.getResponse.results) {
      return this.getResponse.results.totalCount || 0;
    } else {
      return 0;
    }
  }

  get getGetRequest() {
    return this.getRequest;
  }

  // MutationActions
  @MutationAction
  async get(getRequest: PushDeliveryGetRequest) {
    const getResponse = await AnalyticsPushDeliveryAPI.get(getRequest);
    return {
      getResponse,
      getRequest
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      getResponse: {} as PushDeliveryGetResponse
    };
  }
}

export default getModule(Get);
